import { jsx as _jsx } from "react/jsx-runtime";
import IntlProvider from "./IntlProvider";
import { Provider as ReduxProvider } from "react-redux";
/* The ReduxIntlProvider combines the ReduxProvider (that makes the redux store available
 * to the children of the ReduxProvider component) with the IntlProvider, that makes
 * react-intl available to the children of the IntlProvider.
 *
 * The result is that we have the settings (locale) and translated messages for the currently
 * active language available in the Redux store (state.intl), and any changes to it there
 * will result in re-rendering of all components using those settings (i.e. changing language).
 */
export const ReduxIntlProvider = ({ store, children }) => (_jsx(ReduxProvider, { store: store, children: _jsx(IntlProvider, { children: children }) }));
